import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from 'applicaiton/store';

/**
 * Custom hook to use dispatch.
 * It provides access to the dispatch function of the Redux store,
 * which is used to send actions to the reducer and update the state.
 * @returns the dispatch function of the Redux store.
 */
export const useAppDispatch: () => AppDispatch = useDispatch;

/**
 * Custom hook to use selector.
 * It provides access to the selected slice of the Redux state,
 * based on the provided selector function.
 * @param selector the selector function that determines which slice of the Redux state to select.
 * @returns the selected slice of the Redux state.
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
